import React, { createContext, useEffect, useState } from "react";
import { App } from "./App";
import { DataContextProvider } from "./context/DataContext";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./authentication/AuthContextProvider";
import { Login } from "./components/login/Login";
import { ProtectedRoute } from "./authentication/ProtectedRoute";
import { Toastify } from "./components/common/Toastify";
import { IApiContext } from "./interfaces/IApiContext";
import { GetApiContext, initialApiContext } from "./helpers/ctxHelper";
import { PasswordForm } from "./components/login/PasswordForm";
import { SupportPage } from "./components/support/SupportPage";
export const ApiContext = createContext(initialApiContext);
export const Root = () => {
  const [context, setContext] = useState<IApiContext>();

  const InitApp = () => {
    const apiContext = GetApiContext();
    setContext(apiContext);
  };

  useEffect(() => {
    InitApp();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <DataContextProvider>
          <ApiContext.Provider value={context}>
            <Toastify />
            <Routes>
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <App />
                  </ProtectedRoute>
                }
              />

              <Route path="/set-password" element={<PasswordForm />} />
              <Route path="/login" element={<Login />} />
              <Route path="/support" element={<SupportPage />} />
            </Routes>
          </ApiContext.Provider>
        </DataContextProvider>
      </AuthProvider>
    </Router>
  );
};
